export interface AbortError extends Error {
  name: 'AbortError';
}

export function isAbortError(err: unknown): err is AbortError {
  if (!err || typeof err !== 'object') return false;

  // Check for DOMException with AbortError name (standard case)
  if (err instanceof DOMException && err.name === 'AbortError') {
    return true;
  }

  // Fallback for non-DOMException objects with AbortError name (mocks, polyfills, etc.)
  return 'name' in err && err.name === 'AbortError';
}
